import React, { memo } from 'react';
import Button from '../../components/common/UI/Inputs/Button';
import errorimg from '../../assets/images/404.png';
import logo from '../../assets/images/logo-gray.png';
import StackTrace from 'stacktrace-js';
import { getStoredValue, setStoredValue } from "../../_helpers/storagehelper";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
    this.state = { error: '' };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error: error };
  }

  getBrowserType = () => {
    const userAgent = navigator.userAgent;

    if (userAgent.includes("Firefox")) {
      return "Firefox";
    } else if (userAgent.includes("Chrome") && !userAgent.includes("Edg")) {
      return "Chrome";
    } else if (userAgent.includes("Safari") && !userAgent.includes("Chrome")) {
      return "Safari";
    } else if (userAgent.includes("Opera") || userAgent.includes("OPR")) {
      return "Opera";
    } else if (userAgent.includes("Trident")) {
      return "Internet Explorer";
    } else if (userAgent.includes("Edg")) {
      return "Edge";
    }
    else if (userAgent.indexOf("Edg/") > -1) {
      return "Edge";
    } else if (
      userAgent.indexOf("OPR/") > -1 ||
      userAgent.indexOf("Opera") > -1
    ) {
      return "Opera";
    } else if (userAgent.indexOf("Chrome") > -1) {
      return "Chrome";
    } else if (userAgent.indexOf("Safari") > -1) {
      return "Safari";
    } else if (userAgent.indexOf("Firefox") > -1) {
      return "Firefox";
    } else if (
      userAgent.indexOf("Trident") > -1 ||
      userAgent.indexOf("MSIE") > -1
    ) {
      return "Internet Explorer";
    } else {
      return "Unknown";
    }
  };

  // LogErrorApi = async (error) => {
  //   const storedLoginDetails = getStoredValue("loginDetails");
  //   const errorLog = {
  //     Message: error?.Message,
  //     StackTrace: error?.Source,
  //     CurrentURL: window.location.href,
  //     TargetSite: '',
  //     Source: error?.Source,
  //     IPAddress: getStoredValue("cachedIP") || 'Unknown',
  //     Browser: error?.IPAddress,
  //     FacilityCode :storedLoginDetails?.FacilityCode,
  //     KioskCode : storedLoginDetails?.KiosksCode,
  //     MacAddress : storedLoginDetails?.KiosksMacAddress,
  //     PageInfo:error?.Source
  //   };
  //   await fetch(`${process.env.REACT_APP_API_URL}/ErrorLog/logs`, {
  //     method: 'POST',
  //     headers: {
  //       'Content-Type': 'application/json',
  //     },
  //     body: JSON.stringify({
  //       path: "Logs/CreateErrorLog",
  //       errorLog: JSON.stringify(errorLog)
  //     })
  //   }).then((response) => {
  //     if (response.ok) {
  //       return response.json();
  //     } else {
  //       throw new Error('Network response was not ok');
  //     }
  //   });
  // }

  componentDidCatch(error, errorInfo) {
    StackTrace.fromError(error).then(stackFrames => {
      const frame = stackFrames[0]; // top frame
      const fileName = "File : " + frame.fileName || '';
      const lineNumber = "Line number : " + frame.lineNumber;
      const time = "Date and Time : " + new Date().toISOString();

      const logData = {
        Source: `${fileName}, ${lineNumber} , ${time}`,
        Message: error.toString() || 'Unknown error',
        CurrentURL: window.location.href,
        IPAddress: getStoredValue("cachedIP"), // You'll need to capture this on the backend or via a public IP service
        Browser: this.getBrowserType(),
      };
      // this.LogErrorApi(logData);
      console.error("Error Report:", JSON.stringify(logData, null, 2));
    });
  }


  render() {
    if (this.state.hasError) {
      return (
        <div className="parent-container">
          <div className="error-container">
            <div className="error-logo">
              <img src={logo} alt="Logo" />
            </div>
            <div className="error-content">
              <div className="error-code">
                <img src={errorimg} alt="Logo" />
              </div>
              <p className="error-message">
                {this.state.error?.message || 'The Server encountered an internal error and unable to process your request at this time. Please try again after sometime or contact your administrator if the problem persists.'}
              </p>
              <div className="d-flex justify-content-center">
                <Button
                  variant="primary"
                  className="me-2"
                  onClick={() => { window.location.href = '/' }}
                  label="BACK TO LOGIN"
                  type="button"
                  status="primary"
                />
              </div>
            </div>
            <div className="error-footer">
              <p>Copyright © {new Date().getFullYear()} by inmate inbox. All Rights Reserved.</p>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default memo(ErrorBoundary);
